// extracted by mini-css-extract-plugin
export default {"projects-container":"ProjectsSection_projects-container__Ib3Ak","projects-list-container":"ProjectsSection_projects-list-container__W8vy0","even":"ProjectsSection_even__Z2aTk"};